/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useRef, useState } from 'react';
import { saveAs } from 'file-saver';

/** Common Components */
import CardSection from '../../../../components/ui/card/CardSection';
import FormCreator from '../../../../components/finalForms/FormCreator';
import {  customRowsPerPageDropdown, getDropdownValue } from '../../../../components/finalForms/libs/data/dropdownUtilities';
import { ServiceLocationContext } from '../../../../utils/context/ServiceLocationContext';
import formatDate from '../../../../components/finalMolGrid/libs/formatDate';
import MolGrid, { Column } from '@moltech/molui/molgrid';
import ToastService from '../../../../services/toastService/ToastService';
import SwalAlert from '../../../../services/swalService/SwalService';

/** Configuration files */
import { InvoiceSearchFields } from '../outstandingInvoices/components/InvoicesSearchFilters.data';

/**Wrapped Component */
import Financial from '../../Financial';

/** API call */
import { useDeleteDraftInvoiceMutation, useExportDraftInvoicesMutation } from '../../../../app/services/financialsAPI';
import { useGetMolGridDataMutation } from '../../../../app/services/commonAPI';

const DraftInvoices = () => {

  const { selectedLocation } = useContext(ServiceLocationContext);
  const locationkey = getDropdownValue(selectedLocation);
  const { confirm } = SwalAlert();

  const searchFormRef = useRef(null);

  const gridRef = useRef();

  const [searchText, setSearchText] = useState('');
  const currentDate = formatDate(new Date(), "MM-DD-YYYY");
  const [isDisable, setIsDisable] = useState(true);

  const [exportDraftInvoices, {
    isLoading: isExporting,
    isSuccess: isAllExported,
    data: exportAllData
  }] = useExportDraftInvoicesMutation();

  const [deleteDraftInvoice, { isSuccess: isDraftInvoiceDeleted, data: deleteDraftInvoicesData }] =
    useDeleteDraftInvoiceMutation();

  // Export All Details response handling
  useEffect(() => {
    if (!isExporting && isAllExported && exportAllData) {
      const blob = new Blob([exportAllData]);
      saveAs(blob, `Draft Invoices ${currentDate}.xlsx`);
    }
  }, [isExporting, isAllExported, exportAllData]);

  useEffect(() => {
    if (isDraftInvoiceDeleted && deleteDraftInvoicesData) {
      ToastService.success(deleteDraftInvoicesData.errorMessage);
    }
  }, [isDraftInvoiceDeleted && deleteDraftInvoicesData]);

  useEffect(() => {
    if (gridRef.current) {
      gridRef.current.reload();
    }
  }, [searchText,locationkey,isDraftInvoiceDeleted]);


  const handleInputChange = (formData, updatedData) => {
    setSearchText(updatedData?.invoiceNumber || '');
  }

  const beforeMolGridLoad = (reqPrm) => {
    const req = {
      pagination: {
        pageNumber: (reqPrm.first / reqPrm.rows) + 1,
        pageSize: reqPrm.rows
      },
      sortField: reqPrm.sortField,
      sortOrder: reqPrm.sortOrder,
      plServiceLocationKey: locationkey,
      sSearchInvoiceNumber: searchText || '',
      groupBy: reqPrm.groupBy ? reqPrm.groupBy : '',
    };
    return req;
  }

  const afterMolGridLoad = (data) => {
    setIsDisable(false);
    return {
      data: data.dataSource,
      count: data.totalRecord
    };
  }
  const DeleteDraftInvoice = (rowData) => {
    if (rowData?.lInvoiceKey) {
      confirm(
        "Delete?",
        "Are you sure you want to delete this draft invoice?",
        "Delete",
        "Cancel"
      ).then((confirmed) => {
        if (confirmed) {
          deleteDraftInvoice(rowData.lInvoiceKey);
        }
      });
    }
  }

  const getCtxMenuItems = (row) => {
    if (!row) return [];

    return [
      {
        label: 'Delete Draft Invoice',
        command: () => DeleteDraftInvoice(row),
      },
    ];
  }

  const handleExportClick = () => {
    const requestData = {
      plServiceLocationKey: locationkey,
      sSearchInvoiceNumber: searchText || '',
    }
    exportDraftInvoices(requestData);
  }


  return (
    <div className='small-card-btn-sec head-center outstanding-list'>
      <FormCreator
        ref={searchFormRef}
        config={InvoiceSearchFields}
        onColumnChange={handleInputChange}
      />
      <CardSection
        cardTitle={`Draft Invoices`}
        isButtonVisible={true}
        titleButtonClick={handleExportClick}
        rightButton={true}
        titleText={'Export'}
        isIcon={true}
        iconClass="file-icons:microsoft-excel"
        buttonClassName={'blue-btn'}
        isButtonLoading={isExporting}
        isButtonDisable={isDisable}
      >
        <div className="scrollable-grid">
          <MolGrid ref={gridRef} url="/Financials/GetAllDraftInvoices" client={useGetMolGridDataMutation}
            beforeLoad={beforeMolGridLoad}
            afterLoad={afterMolGridLoad}
            grouping
            expandableRowGroups={true}

            scrollable
            scrollHeight="flex"
            filterDisplay="row"

            sortMode="single"
            showGridlines
            resizableColumns

            paginator
            rowsPerPageOptions={[10, 25, 50, 100]}
            rows={99999}
            paginatorTemplate={{
              layout: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
              RowsPerPageDropdown: (options) => {
                return customRowsPerPageDropdown(options, options?.value)
              }
            }}
            ctxMenuItems={getCtxMenuItems}
          >
            <Column field="customer" header="Customer" grouping sortable />
            <Column field="sTranNumber" header="Invoice Number" bodyStyle={{ textAlign: "center" }} grouping sortable />
            <Column field="dtTranDate" header="Invoice Date" colType="datetime" format="mm/dd/yyyy" grouping bodyStyle={{ textAlign: "center" }} sortable />
            <Column field="salesRep" header="Sales Rep" bodyStyle={{ textAlign: "center" }} grouping sortable />
            <Column field="model" header="Model" bodyStyle={{ textAlign: "center" }} grouping sortable />
            <Column field="serialNumber" header="Serial Number" bodyStyle={{ textAlign: "center" }} sortable />
            <Column field="sPurchaseOrder" header="Purchase Order" bodyStyle={{ textAlign: "center" }} sortable />
            <Column field="trackingRequired" header="Tracking Req." bodyStyle={{ textAlign: "center" }} grouping sortable />
            <Column field="trackingNumber" header="Tracking #" sortable />
            <Column field="draftReason" header="Draft Reason" sortable />
          </MolGrid>
        </div>
      </CardSection>
    </div>

  )
}
export default Financial(DraftInvoices)